import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const AddResourceInstanceFormSchema = z.object({
  instanceNumber: z.number().optional(),
  namespace: z.enum(['cnx', 'frg'], { message: 'Namespace is required' }),
  resourceCategory: z.enum(['artifact', 'component', 'product', 'cloud', 'user-data'], {
    message: 'Category is required',
  }),
  resourceTypeNumber: z
    .coerce
    .number()
    .int('Resource Type must be selected')
    .min(1, 'Resource Type is required'),
  parentInstancePaths: z.array(z.object({
    resourceType: z.string(),
    instanceId: z.string(),
  })).optional().default([]),
  resourceInstanceName: z
    .string()
    .min(2, 'Instance Name must be at least 2 characters')
    .max(100, 'Instance Name cannot exceed 100 characters'),
  resourceInstanceDescription: z
    .string()
    .min(1, 'Description is required')
    .max(500, 'Description cannot exceed 500 characters'),
})

export type AddResourceInstanceFormData = z.infer<typeof AddResourceInstanceFormSchema>

export function transformToApiRequest(formData: AddResourceInstanceFormData) {
  return {
    instanceNumber: formData.instanceNumber,
    namespace: formData.namespace,
    tenantId: formData.namespace === 'cnx' ? 997 : 897,
    resourceCategory: formData.resourceCategory,
    resourceTypeNumber: formData.resourceTypeNumber,
    parentInstancePaths: formData.parentInstancePaths ?? [],
    resourceInstanceName: formData.resourceInstanceName.trim(),
    resourceInstanceDescription: formData.resourceInstanceDescription.trim(),
  }
}
